import { Search2Icon } from '@chakra-ui/icons'
import { Box, Flex, Heading, Text } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import Link from 'next/link'
import React from 'react'

import { Container } from '@/components/Container'
import { Head } from '@/components/Head'
import { Header } from '@/components/Header'
import { Layout } from '@/components/Layout'

const Terms = () => {
  return (
    <Layout>
      <Head path="/faq" title="FAQ" />
      <Container>
        <Header />
        <Box mt="8" fontWeight="bold">
          <Heading as="h1">FAQ</Heading>
          <Box mt="4">
            <Text fontSize="xl">What can I do with my CryptoUkiyoe?</Text>
            <Box mt="2">
              <Text>
                I grant you a license to use CryptoUkiyoe Art. (Please refer to
                <Link href="/terms" prefetch={false}>
                  <a>
                    <chakra.span ml="1" color="#f79128" _hover={{ color: '#d95764' }}>
                      Terms & Conditions
                    </chakra.span>
                  </a>
                </Link>
                )
              </Text>
              <Text>
                Your Art images can be downloaded in any size on
                <Link href="/collections" prefetch={false}>
                  <a>
                    <chakra.span mx="1" color="#f79128" _hover={{ color: '#d95764' }}>
                      My Collection
                    </chakra.span>
                  </a>
                </Link>
                page.
              </Text>
            </Box>

            <Text mt="8" fontSize="xl">
              How much is each CryptoUkiyoe?
            </Text>
            <Box mt="2">
              <Text>The price is determined by the rarity of the Ukiyoe Type.</Text>
              <Flex mt="2" direction="column">
                <Flex>
                  <Text minW="32">
                    <Search2Icon w={2} h={2} />
                    <Link href="/attributes/type/Male" prefetch={false}>
                      <a>
                        <chakra.span ml="2" color="#f79128" _hover={{ color: '#d95764' }}>
                          Male
                        </chakra.span>
                      </a>
                    </Link>
                  </Text>
                  <Text>0.05 ETH</Text>
                </Flex>
                <Flex mt="2">
                  <Text minW="32">
                    <Search2Icon w={2} h={2} />
                    <Link href="/attributes/type/Female" prefetch={false}>
                      <a>
                        <chakra.span ml="2" color="#f79128" _hover={{ color: '#d95764' }}>
                          Female
                        </chakra.span>
                      </a>
                    </Link>
                  </Text>
                  <Text>0.05 ETH</Text>
                </Flex>
                <Flex mt="2">
                  <Text minW="32">
                    <Search2Icon w={2} h={2} />
                    <Link href="/attributes/type/Ninja" prefetch={false}>
                      <a>
                        <chakra.span ml="2" color="#f79128" _hover={{ color: '#d95764' }}>
                          Ninja
                        </chakra.span>
                      </a>
                    </Link>
                  </Text>
                  <Text>1.00 ETH</Text>
                </Flex>
                <Flex mt="2">
                  <Text minW="32">
                    <Search2Icon w={2} h={2} />
                    <Link href="/attributes/type/Kabuki" prefetch={false}>
                      <a>
                        <chakra.span ml="2" color="#f79128" _hover={{ color: '#d95764' }}>
                          Kabuki
                        </chakra.span>
                      </a>
                    </Link>
                  </Text>
                  <Text>5.00 ETH</Text>
                </Flex>
              </Flex>
            </Box>

            <Text mt="8" fontSize="xl">
              How can I help?
            </Text>
            <Box mt="2">
              <Text>This is my personal project, so I have no marketing power.</Text>
              <Text>
                If you like this project, I really appreciate it if you could share it on SNS.
              </Text>
            </Box>
          </Box>
        </Box>
      </Container>
    </Layout>
  )
}

export default Terms
